import { InjectionToken } from '@angular/core';
import { HttpContextToken } from '@angular/common/http';
import { Auth } from '@angular/fire/auth';
import { FirebaseApp } from '@angular/fire/app';

export const BYPASS_AUTH = new HttpContextToken<boolean>(() => false);

export const DEV_FIREBASE_APP = new InjectionToken<FirebaseApp>('dev-firebase-app');
export const DEV_FIREBASE_AUTH = new InjectionToken<Auth>('dev-firebase-auth');
